/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Højre mod venstre",
		"timeZoneID": "Tidszone",
		"skin": "Typografi",
		"metricsFileImportTask": "Ny import fra filer",
		"displayMode": "Standardvisning",
		"credentialRenewed": "Dine legitimationsoplysninger blev fornyet med din aktuelle bruger-id og dit aktuelle kodeord.",
		"productLocale": "Produktsprog",
		"toggleDisabled": "fra",
		"credentialChange": "Forny",
		"log_level_Debug": "Fejlsøgning",
		"confirmNewPassword": "Bekræft nyt kodeord",
		"unsavedViewMsg2": "Dine ændringer går tabt, hvis du ikke gemmer dem først.",
		"supportPortalErrorMessage": "Prøv igen.  Kontakt administratoren, hvis problemet opstår igen.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, the IBM logo, ibm.com and Cognos are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide. A current list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml. This Program is licensed under the terms of the license agreement accompanying the Program. This license agreement may be either located in a Program directory folder or library identified as \"License\" or \"Non_IBM_License\" if applicable, or provided as a printed license agreement. Please read the agreement carefully before using the Program. By using the Program you agree to these terms.",
		"groupsAndRoles": "Grupper og roller",
		"metricsMaintenanceTask": "Ny vedligeholdelse",
		"email": "E-mail",
		"contextual": "Kontekstbaseret",
		"resetHome": "Nulstil til standard",
		"ltr": "Venstre mod højre",
		"credentials": "Legitimationsoplysninger",
		"logging_congfig_title": "Logning",
		"changePasswordTitle": "Skift mit kodeord",
		"format": "Rapportformat",
		"showUnread": "Vis ulæste",
		"AILearning_active": "AI-læring er slået til:",
		"docsErrorMessage": "Prøv igen.  Kontakt administratoren, hvis problemet opstår igen.",
		"toggleEnabled": "til",
		"homeSetError": "Der er opstået en fejl under angivelsen af standardhjemmesiden. Prøv at lukke og genåbne denne oversigt.",
		"passwordChange": "Skift dit kodeord",
		"profile": "Profil",
		"pdfRestricted": "PDF (begrænset)",
		"drillThrough": "Drill-through-definitioner",
		"homeSet": "Din Hjem-side er angivet",
		"regionalOptions": "Regionale indstillinger",
		"myPreferences": "Mine indstillinger",
		"defaultHome": "Standard",
		"version": "Version",
		"controller": "Controller",
		"manage": "Administrér",
		"biDirectionalFeaturesEnabled": "Understøttelse af BIDI-sprog",
		"newFeaturesErrorTitle": "Linket til Nye funktioner fungerede ikke",
		"passwordMatch": "Kodeordsmatch",
		"updateProfileAndsettings": "Opdatér profil og indstillinger",
		"dashboardConsole": "Arbejdsområde",
		"legacyAppsSlideoutLabel": "Tilgængelige ældre applikationer",
		"logging_config_description": "Logning bruges til fejlfinding. Kontakt administratoren, hvis du vil have hjælp til indstillingerne.",
		"confirmDeletion": "Bekræft sletning",
		"signInButtonText": "Log på",
		"dataSourceCredentials": "Legitimationsoplysninger til dataserver",
		"AILearningConfigurationSlideoutAllyLabel": "Konfiguration af AI-læring",
		"loadingSettings": "Indlæser indstillinger",
		"spreadsheetMLRestricted": "Excel (begrænset)",
		"manageAILearning": "AI-læring",
		"xlsxDataRestricted": "Excel-data (begrænset)",
		"advanced": "Udvidede indstillinger",
		"ok": "OK",
		"changeEmail": "Skift",
		"showHints": "Vis tip",
		"general": "Generelt",
		"xlsxData": "Excel-data",
		"newPassword": "Nyt kodeord",
		"hideAll": "Skjul alle",
		"confirmPassword": "Bekræft kodeord",
		"AILearning_config_description": "Du kan forbedre produktanbefalinger ved at tillade, at Cognos Analytics lærer om din brug.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Linket til supportportalen fungerede ikke",
		"log_level_Warn": "Advarsel",
		"contentSettings": "Indholdsindstillinger",
		"setHomeButton": "Sæt",
		"myCapabilities": "Mine muligheder",
		"homePage": "Siden Hjem",
		"helpErrorMessage": "Prøv igen.  Kontakt administratoren, hvis problemet opstår igen.",
		"loadingProfile": "Indlæser profil",
		"portal": "Portal",
		"metricsPackage": "Ny pakke",
		"myCredentials": "Mine legitimationsoplysninger",
		"credentialCreate": "Opret",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Kan ikke opdatere kodeord",
		"showHiddenObjects": "Vis skjulte indgange",
		"csv": "CSV",
		"docsErrorTitle": "Linket til dokumentationen fungerede ikke",
		"log_level_Error": "Fejl",
		"wrongPassword": "Kan ikke validere",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Information",
		"welcomeBanner": "Velkomstbanner",
		"helpErrorTitle": "Linket til hjælpen fungerede ikke",
		"contentLocale": "Indholdssprog",
		"pdf": "PDF",
		"oldPassword": "Gammelt kodeord",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Hjælp til handicappede",
		"manageLogging": "Logning",
		"loggingConfigurationSlideoutA11yLabel": "Konfiguration af logning",
		"communityErrorTitle": "Linket til fællesskabet fungerede ikke",
		"companionApps": "Ledsageapplikationer",
		"setHomeLabel": "Angiv Start som (aktuel oversigt)",
		"metricsExportTask": "Ny eksport",
		"csvRestricted": "CSV (begrænset)",
		"newFeaturesErrorMessage": "Prøv igen.  Kontakt administratoren, hvis problemet opstår igen.",
		"contributor": "Contributor",
		"showAll": "Vis alle",
		"logging_active": "Logning er slået til:",
		"html": "HTML",
		"profileAndSettings": "Profil og indstillinger",
		"baseTextDirection": "Basistekstretning",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Kodeord",
		"invalidEmail": "Angiv en gyldig e-mailadresse",
		"credentialCreateSuccess": "Du har oprettet dine legitimationsoplysninger",
		"settings": "Indstillinger",
		"restrictedFormatSelected": "Du har ikke mulighed for at udføre rapporter i dette format, men du kan anvende rapporter, der er gemt i dette format.",
		"usageDataDeletionConfirmation": "Hvis du sletter brugsdata, nulstilles al AI-læring.  Er du sikker på, at du vil slette brugsdata?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Vis detaljer",
		"deleteUsageData": "Slet brugsdata",
		"showPassword": "Vis kodeord",
		"AILearning_config_title": "AI-læring",
		"myPreferencesSlideoutLabel": "Profil og indstillinger",
		"passWordChangeSuccess": "Du har ændret dit kodeord",
		"logging_level": "Logningsniveau:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Prøv igen.  Kontakt administratoren, hvis problemet opstår igen.",
		"cancel": "Annullér",
		"shareSetError": "Handlingen kan ikke udføres, før du lukker og genåbner denne oversigt.",
		"passwordNotMatch": "Kodeord matcher ikke",
		"xml": "XML",
		"xmlRestricted": "XML (begrænset)",
		"openMenu": "Åbn menu",
		"closeMenu": 'Luk menu'
});